import { createContainer } from 'brandi';

const container = createContainer();

export default container;